// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Community extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Ícone comunidade</title>
        <desc>Ícone de um balão de fala</desc>
        <g id="icon-community">
          <path d="M8,13H4C0,13,0,9.1,0,8V4C0,2.89,0,0,4,0h8c1.1,0,4,0,4,4V9c0,1.1,0,4-3,4H12v2a1,1,0,0,1-1.7.71ZM12,2H4A2,2,0,0,0,2,4V9a2,2,0,0,0,2,2H9l1,1V11h2a2,2,0,0,0,2-2V4A2,2,0,0,0,12,2Z" />
        </g>
      </svg>
    );
  }
}

export default Community;
